export default __webpack_public_path__ + "static/media/2438.c5e68071.png";